import React from 'react';

export default function Avatar({ person: { id, type }, altText, renderFallback, ...imgProps }) {
  return <React.Fragment>{renderFallback && renderFallback()}</React.Fragment>;
}
